import Vue from 'vue'

export const state = () => ({
  siteKey: process.env.environment.captcha.v2,
  formData: {}
})

export const getters = {
  getFormField: (state) => (id) => {
    return state.formData[id] || ''
  },
  getFormData: (state) => {
    return state.formData
  }
}

export const mutations = {
  setFormField(state, { type, value }) {
    if (!state.formData[type]) Vue.set(state.formData, type, value)
    state.formData[type] = value
  }
}

export const actions = {}
